export default __webpack_public_path__ + "static/media/landbot.c90edb5c.png";